import {
  defineAccountImagePolicies,
  defineDynamicResourcePolicies,
  defineGlobalPolicies,
  defineRolePolicies,
} from '@scalified-monorepo/shared/casl';
import {defineSamplePolicies} from './sample.policies';

export * from './sample.policies';
export const samplePolicies = [
  defineSamplePolicies,

  // Account image self-grants derive from the per-identity account grants
  defineAccountImagePolicies,

  // Global policies must run BEFORE domain-specific restriction policies
  // so their broader can() rules do not override narrower cannot() rules
  defineGlobalPolicies,

  // Domain-specific restriction policies run LAST
  defineRolePolicies,
  defineDynamicResourcePolicies,
];
